import { NetworkStatus } from '@cbridge-utils/network';
import { IClientLpStore } from './clientLp.interface';

export const clientLpListInitialState: IClientLpStore = {
  data: {},
  listNetworkStatus: NetworkStatus.None,
  adapterSchemas: {},
};
